import { useQuery } from "@tanstack/react-query";
import axios from "../axios";

const useGetAllBalance = () => {
  return useQuery({
    queryKey: ["balances"],
    queryFn: async () => {
      const response = await axios.get("api/balance/balances"); // endpoint change
      return response.data;
    },
    staleTime: 30000, // optional: 30 seconds
  });
};

export default useGetAllBalance;
